import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Alert,
} from '@mui/material';
import {
  Cancel as CancelIcon,
  Home as HomeIcon,
  Refresh as RefreshIcon,
} from '@mui/icons-material';
import { useTheme } from 'styled-components';
import { NavHeader } from '../../components/NavHeader';
import { Container, FailedCard, IconContainer, ButtonContainer } from './styles';

export function CheckoutFailed() {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Verificar se há parâmetros de erro na URL
    const errorParam = searchParams.get('error');
    if (errorParam) {
      setError(decodeURIComponent(errorParam));
    }
  }, [searchParams]);

  const handleRetryPayment = () => {
    navigate('/subscribe');
  };

  return (
    <>
      <NavHeader typeHeader="default" />
      <Container>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="60vh"
          gap={3}
        >
          <FailedCard>
            <CardContent>
              <IconContainer>
                <CancelIcon sx={{ fontSize: 80, color: theme.colors.error }} />
              </IconContainer>

              <Typography variant="h4" component="h1" color={theme.colors.secondary} textAlign="center" gutterBottom>
                Pagamento Não Realizado
              </Typography>

              <Typography variant="body1" color="text.secondary" textAlign="center" mb={3}>
                Ocorreu um problema ao processar seu pagamento. Não se preocupe, nenhuma cobrança foi realizada.
              </Typography>

              {error && (
                <Alert severity="error" sx={{ mb: 3 }}>
                  {error}
                </Alert>
              )}

              {sessionId && (
                <Box mb={3}>
                  <Typography variant="body2" color="text.secondary" textAlign="center">
                    ID da Sessão: {sessionId}
                  </Typography>
                </Box>
              )}

              <Typography variant="body2" color="text.secondary" textAlign="center" mb={3}>
                Você pode tentar novamente.
              </Typography>

              <ButtonContainer>
                <Button
                  variant="contained"
                  startIcon={<RefreshIcon />}
                  onClick={handleRetryPayment}
                  sx={{ backgroundColor: theme.colors.primary }}
                >
                  Tentar Novamente
                </Button>
              </ButtonContainer>
            </CardContent>
          </FailedCard>
        </Box>
      </Container>
    </>
  );
}
